import Contextmenu from "./Contextmenu.vue";

export default {
    install: (Vue) => {
        const ContextmenuConstructor = Vue.extend(Contextmenu)
        const contextmenuInstance = new ContextmenuConstructor();
        document.body.appendChild(contextmenuInstance.$mount().$el);
        Vue.prototype.$contextmenu = contextmenuInstance.contextmenu;
    }
}